import { render, staticRenderFns } from "./BasicDataTab.vue?vue&type=template&id=b6ad3bfc&scoped=true&"
import script from "./BasicDataTab.vue?vue&type=script&lang=js&"
export * from "./BasicDataTab.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataTab.vue?vue&type=style&index=0&id=b6ad3bfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ad3bfc",
  null
  
)

component.options.__file = "BasicDataTab.vue"
export default component.exports